var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-branch-company',{ref:"table",staticClass:"pt-branch-company__withData",on:{"deleteBranchCompany":_vm.deleteBranchCompany}})}
var staticRenderFns = []

export { render, staticRenderFns }